import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { marginX } from '~/constants'
import { getInfoRestaurant } from '~/utils'
import { HeaderTable } from '~/components'
import { ThemeContext } from '~/theme/ThemeProvider'

// component dùng chung
const OrderEmpty = () => {
  const { t } = useTranslation()
  const { currentThemeObject } = useContext(ThemeContext)

  const renderNameTable = () => {
    const { tableName } = getInfoRestaurant()

    return <HeaderTable name={tableName} colorText={currentThemeObject.colorText1} />
  }

  return (
    <Box marginX={`${marginX}px`} minHeight="100vh">
      {renderNameTable()}
      <Typography
        marginTop="60%"
        component="h2"
        fontSize="2.4rem"
        fontWeight="600"
        lineHeight="3rem"
        color={'baseColor.colorText1'}>
        {t('titles.order_empty')}
      </Typography>
      <Typography
        fontSize="1.6rem"
        fontWeight="400"
        lineHeight="2rem"
        color={'baseColor.colorText1'}>
        {t('descriptions.order_empty')}
      </Typography>
    </Box>
  )
}

export default React.memo(OrderEmpty)
